'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GpaController = function () {
    function GpaController(DataService) {
        'ngInject';

        (0, _classCallCheck3.default)(this, GpaController);
        this.DataService = DataService;
    }

    (0, _createClass3.default)(GpaController, [{
        key: 'calcAvgGpa',
        value: function calcAvgGpa() {
            console.log('before:', this.data);
            var calcClassGra = function calcClassGra(_class) {
                return _class.reduce(function (pr, cur) {
                    return { gpa: +pr.gpa + +cur.gpa };
                }, { gpa: 0 }).gpa / _class.length;
            };
            this.totalGPA = this.data.reduce(function (r, c) {
                return r + +calcClassGra(c.childes);
            }, 0) / this.data.length;
        }
    }, {
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.DataService.API().query({ type: 'classes.json', id: '' }).$promise.then(function (responce) {
                _this.data = responce;_this.selectedClass = 0;_this.calcAvgGpa();
            }, function (error) {
                return console.log('error:', error);
            });
        }
    }, {
        key: 'deleteGrade',
        value: function deleteGrade(index) {
            this.data.splice(index, 1);
            this.calcAvgGpa();
        }
    }, {
        key: 'addGrade',
        value: function addGrade() {
            if (this.data.findIndex(function (e) {
                return e.grade === '';
            }) !== -1) return;
            this.data.push({
                "grade": "",
                "childes": []
            });
        }
    }, {
        key: 'addStudent',
        value: function addStudent() {
            this.data[this.selectedClass].childes.push(this.newStudent);
            this.newStudent = { name: '', gpa: '' };
            this.calcAvgGpa();
        }
    }, {
        key: 'removeStudent',
        value: function removeStudent(index) {
            console.log('remove index', index);
            this.data[this.selectedClass].childes.splice(index, 1);
            this.calcAvgGpa();
        }
    }]);
    return GpaController;
}();

exports.default = GpaController;


// WEBPACK FOOTER //
// ./client/app/components/gpa/gpa.controller.js